<template>
  <base-select
    :select-options="selectOptions"
    :required="false"
    name="within-in"
    data-test="within-in"
    @change="selectionChanged($event)"
  >
    <template #label>
      <translate>Radius</translate>
    </template>
    <template #label-status> &#8203; </template>
  </base-select>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { SelectOption } from '../../../../../components/base/BaseSelect.vue'

@Component({
  emits: ['input'],
})
class WithinInput extends Vue {
  @Prop({ required: true, type: Number })
  value: number

  get valueOrDefault() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access -- Nuxt $config.public type needs refinement
    return this.value || this.$config.public.defaultWithinRange
  }

  selectionChanged(selection: { selectedValue: string }) {
    const range = Number(selection.selectedValue)
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- Nuxt $config.public type needs refinement
    const result = isNaN(range) ? this.$config.public.defaultWithinRange : range
    this.$emit('input', result)
  }

  get selectOptions() {
    const options: SelectOption[] = []
    const maxValue = 95
    const currentValue = Math.min(this.valueOrDefault, maxValue)
    const step = 5
    for (let value = 5; value <= maxValue; value += step) {
      options.push(this.formatOption(value))
    }
    // if the current value not in the list, let's add it
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- TODO: Add proper type for currentValue and option value property
    if (!options.some((option) => option.value === currentValue.toString())) {
      options.push(this.formatOption(currentValue))
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- Sort comparison needs type refinement
      options.sort((a, b) => Number(a.value) - Number(b.value))
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return -- Options array type needs refinement
    return options
  }

  formatOption(value: number): SelectOption {
    return {
      value: value.toString(),
      name: this.$t('{value, localeDistance, long}', { value }),
      // would be better to pass selected as a value to the top
      selected: value === this.valueOrDefault,
    }
  }
}

export default toNative(WithinInput)
</script>
